export default __webpack_public_path__ + "static/media/mhub_accounts.0df89066.svg";